export default {

}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/components/resources/methods.js